import styles from './style.module.css';

// psy's mascot, the happy Cloud brain the owner chose on 2026-10-16: a
// sunflower brain with an ink outline, two eyes that blink and a smile. Its
// face is the same everywhere and never answers what someone recorded (C13).
//
// It is drawn in layers, one glyph each, so every part takes its colour from
// the theme: the body the accent, the outline the ink, which turns light in
// the dark theme, and the face the accent's own dark ink. breathe swaps the
// blink for one slow breath every ten seconds, for the landing page. The
// mascot is always decorative: whatever it stands beside names it.
export function Mascot({ size, breathe }) {
  let className = styles.mascot;
  let lids = null;

  if (breathe === true) {
    className = `${ styles.mascot } ${ styles.breathe }`;
    lids = <span className={ `${ styles.part } ${ styles.lids }` }></span>;
  }

  return (
    <span className={ className } style={ { '--size': `${ size }px` } } aria-hidden='true'>
      <span className={ styles.body }>
        <span className={ `${ styles.part } ${ styles.fill }` }></span>
        <span className={ `${ styles.part } ${ styles.outline }` }></span>
        <span className={ `${ styles.part } ${ styles.eyes }` }></span>
        { lids }
        <span className={ `${ styles.part } ${ styles.smile }` }></span>
      </span>
    </span>
  );
}
